import { TagList } from '@mews-commander/ui';
import { Container } from '@optimus-web/core';
import { useGetServiceNamesByIdQuery } from '../queries/useGetServiceNamesByIdQuery';

interface ServicesCellProps {
    serviceIds: string[];
}

export const ServicesCell = ({ serviceIds }: ServicesCellProps) => {
    const { data: serviceNamesById } = useGetServiceNamesByIdQuery();
    const services = serviceIds.map((id) => serviceNamesById[id]);

    return (
        <Container maxHeight="160px">
            <TagList tagsVariant="basicSubtle" tags={services.toSorted()} />
        </Container>
    );
};
